export const uk = {
    'not-found': 'Ничего не найдено',
    'not-selected': 'Нет выбранных',
    'search-placeholder': 'Найти эксперимент или сегмент',
    title: 'Корректировки ставок'
};
